import React, { useContext, useState } from "react";
import './StepSelector.scss';
import { Modal } from "uxp/components";
import { getRegisteredSteps } from "@utils";
import { QueryBuilderContext } from "@query-builder/QueryBuilderContext";
export const StepSelector = props => {
    var _a;
    const { onSelect } = props;
    const context = useContext(QueryBuilderContext);
    const $L = (key) => context.uxpContext.$L(key);
    const [show, setShow] = useState(false);
    function handleSelect(type) {
        onSelect(type);
        setShow(false);
    }
    return React.createElement("div", { className: "lqe-ss__btn-wrap-f17c6eea" },
        React.createElement("div", { className: "lqe-ss__btn-f17c6eea", onClick: () => {
                setShow(true);
            } }, $L('lqe.ss.add-step-btn')),
        React.createElement(Modal, { show: show, onClose: () => setShow(false), className: "lqe-ss__modal-f17c6eea", autoSize: true, title: $L('lqe.ss.modal-title') },
            React.createElement("div", { className: "lqe-ss__types-f17c6eea" }, (_a = getRegisteredSteps()) === null || _a === void 0 ? void 0 : _a.map((step, i) => React.createElement("div", { className: "lqe-ss__type-f17c6eea", key: i, onClick: () => handleSelect(step.type) },
                React.createElement("div", { className: "lqe-ss__type-ico-f17c6eea" },
                    React.createElement("div", { className: "lqe-ss__ico-img-f17c6eea", style: {
                            WebkitMaskImage: `url(${step.icon})`,
                            maskImage: `url(${step.icon})`
                        } })),
                React.createElement("div", { className: "lqe-ss__type-details-f17c6eea" },
                    React.createElement("div", { className: "lqe-ss__type-name-f17c6eea" }, $L(step.name)),
                    React.createElement("div", { className: "lqe-ss__type-desc-f17c6eea" }, $L(step.description))))))));
};
